export default "__VITE_ASSET__BFKxIk_X__"